export default __webpack_public_path__ + "static/media/36I-114280_-20875_0.ea2abaee.jpg";